export const getCompanies = (state) => state.companies

// export const getSelectCompany = (state) => state.searchedCompany

export const getSelectedCompany = (state) => state.selectedCompanyId
